import React from 'react';

interface CheckboxProps {
  tabIndex?: number;
  size?: 'sm' | 'md';
  name?: string;
  value?: string;
  id?: string;
  onClick?: () => void;
  onChange?: (value: boolean) => void;
  checked?: boolean;
  additionalStyle?: string;
  customIcon?: React.ReactNode;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  tabIndex,
  size,
  name,
  value,
  id,
  onClick,
  onChange,
  checked,
  additionalStyle,
  customIcon,
}) => {
  let beforeWidthHeight = '';

  switch (size) {
    case 'sm':
      beforeWidthHeight = 'before:w-7 before:h-7';
      break;
    case 'md':
    default:
      beforeWidthHeight = 'before:w-10 before:h-10';
      break;
  }

  return (
    <label
      className={`relative flex w-fit items-center justify-center before:absolute before:rounded-full ${beforeWidthHeight} before:left-1/2 before:top-1/2 before:-translate-x-1/2 before:-translate-y-1/2 before:cursor-pointer hover:before:bg-[#eaeaed] dark:hover:before:bg-[#545454]`}
      onClick={onClick}
    >
      <input
        type="checkbox"
        tabIndex={tabIndex ? tabIndex : 0}
        name={name}
        value={value}
        id={id}
        className={`action-check relative h-4 w-4 cursor-pointer rounded border border-gray-300 bg-transparent text-primary checked:border-none dark:border-[white] dark:border-opacity-40 ${additionalStyle}`}
        checked={checked}
        onChange={(e) => onChange?.(e.target.checked)}
        onClick={onClick}
      />
      {customIcon && (
        <div className="pointer-events-none absolute">{customIcon}</div>
      )}
    </label>
  );
};
